import { defineNuxtPlugin } from "nuxt/app";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default defineNuxtPlugin(() => {
});
